import { render, staticRenderFns } from "./update-log.vue?vue&type=template&id=62dd064f"
import script from "./update-log.vue?vue&type=script&lang=js"
export * from "./update-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports